<script setup lang="ts">
import DetectionsDesktopAdvancedFilters from '@/components/Filters/Detections/Desktop/DetectionsDesktopAdvancedFilters.vue'
import DetectionsDesktopFilters from '@/components/Filters/Detections/Desktop/DetectionsDesktopFilters.vue'
import DetectionsMobileAdvancedFilters from '@/components/Filters/Detections/Mobile/DetectionsMobileAdvancedFilters.vue'
import DetectionsMobileFilters from '@/components/Filters/Detections/Mobile/DetectionsMobileFilters.vue'
import { EHubProvider } from '@/types/enum/HubProviderEnum'
import { EProviders, type ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import { computed, inject, provide, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type { EventQueryResponse } from '../../types/filters/EventFilters'
import type { CheckpointModel } from '../../types/models/CheckpointModel'
import type { EventModel } from '../../types/models/EventModel'
import ExportDetectionButton from '../Buttons/ExportDetectionButton.vue'

const { locale } = useI18n()
const isViewerOnly = inject<boolean>(EHubProvider.IS_VIEWER_ONLY, false)

const DATETIME_FORMAT = computed(() =>
    locale.value === 'en' ? 'L HH:mm:ss.SS' : 'DD/MM/YYYY HH:mm:ss.SS'
)

const query = ref<Record<string, unknown>>()
const changeQueryResponse = (value?: Record<string, EventQueryResponse>) => (query.value = value)

const generateTitle = (detection?: Record<string, ExtendedPrimitives>) =>
    `Bib ${detection?.bib}${detection?.event_filter ? ` - E${detection?.event_filter}` : ''} ${
        detection?.event_filter ? ` - ${detection?.event_filter}` : ''
    }`
const generateSubtitle = (detection?: Record<string, ExtendedPrimitives>) =>
    moment(detection?.timestamp as Date | string)
        .utc()
        .local()
        .format(DATETIME_FORMAT.value)

provide(EProviders.DETECTION, {
    generateTitle,
    generateSubtitle,
    ExportDetectionsComponent: ExportDetectionButton,
    filtersComponents: {
        desktop: {
            filters: DetectionsDesktopFilters,
            advancedFilters: DetectionsDesktopAdvancedFilters
        },
        mobile: {
            filters: DetectionsMobileFilters,
            advancedFilters: DetectionsMobileAdvancedFilters
        }
    },
    advancedFiltersQueryKeys: ['start_at', 'end_at'],

    query,
    changeQueryResponse
})

const filename = (value: Record<string, ExtendedPrimitives>) =>
    `${moment().format('YYYY-MM-DD hh-mm-ss')} ${(value.event as EventModel)?.name?.replace(
        '/',
        '-'
    )} ${(value.checkpoint as CheckpointModel)?.name?.replace('/', '-') ?? 'ALL-CHECKPOINT'}`

provide(EProviders.EXPORT, { filename })
</script>

<template>
    <slot />
</template>
